import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { message } from "antd";

import { QuestionnaireAction } from "../../store/actions";

import {
  Buttons,
  Spacer,
  questionnaireComponents,
  Loader,
} from "../../components";

import "./styles.css";

const Demographics = ({ setPage }) => {
  const dispatch = useDispatch();

  const profileData = useSelector((state) => state.profile?.user);
  const { questionnaire, isLoading } = useSelector(
    (state) => state?.questionnaire
  );

  const [state, setState] = useState({
    uniHistoryImportance: "",
    studentDiversityImportance: "",
  });

  useEffect(() => {
    setState({
      uniHistoryImportance: questionnaire?.uniHistoryImportance ?? "",
      studentDiversityImportance:
        questionnaire?.studentDiversityImportance ?? "",
    });
  }, [questionnaire]);

  const handleNext = () => {
    if (!state.uniHistoryImportance || !state.studentDiversityImportance) {
      message.error("Please fill all the required fields.");
    } else {
      const payload = { userId: profileData?.id, ...state };

      dispatch(
        QuestionnaireAction.addQuestionnaire(payload, (res) => {
          if (res.status === 200) {
            setPage("Others");
          }
        })
      );
    }
  };

  return (
    <div className="text-black">
      {isLoading ? (
        <Loader.Circular />
      ) : (
        <div>
          <questionnaireComponents.QuestionnaireLabel
            text="1. How important is it to you that a university has a long and
             established history?"
            required
          />
          <Spacer height={10} />
          <questionnaireComponents.QuestionnaireCircleInput
            value={state?.uniHistoryImportance}
            handleChange={(e) =>
              setState({ ...state, uniHistoryImportance: e })
            }
          />
          <Spacer height={24} />
          <questionnaireComponents.QuestionnaireLabel
            text="2. How important is the university's student diversity for you?"
            required
          />
          <Spacer height={10} />
          <questionnaireComponents.QuestionnaireCircleInput
            value={state?.studentDiversityImportance}
            handleChange={(e) =>
              setState({ ...state, studentDiversityImportance: e })
            }
          />
          <Spacer height={20} />
          <div className="flex justify-end">
            <div className="w-[12.5em]">
              <Buttons.DefaultButton
                onClick={handleNext}
                size="large"
                width="full"
              >
                Next
              </Buttons.DefaultButton>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Demographics;
